/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetNotificationGroupQuery } from "~/generated/graphql";

type Props = {
  id: string;
};

export function useGetNotificationGroup({ id }: Props) {
  const { data, loading, error } = useGetNotificationGroupQuery({
    variables: { id },
  });

  return {
    data: data?.notificationGroup ?? undefined,
    loading,
    error,
  } as const;
}
